import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconCountry: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM18.9 8H16.6C16.3 6.8 16 5.7 15.5 4.8C16.9 5.5 18.1 6.6 18.9 8ZM14.5 8H9.5C10.1 5.5 11.3 4 12 4C12.7 4 13.9 5.5 14.5 8ZM15 12C15 12.7 15 13.4 14.9 14H9.1C9 13.4 9 12.7 9 12C9 11.3 9 10.6 9.1 10H14.9C15 10.6 15 11.3 15 12ZM8.5 4.8C8.1 5.7 7.7 6.8 7.4 8H5.1C5.9 6.6 7.1 5.5 8.5 4.8ZM4.3 10H7.1C7 10.6 7 11.3 7 12C7 12.7 7 13.4 7.1 14H4.3C4.1 13.4 4 12.7 4 12C4 11.3 4.1 10.6 4.3 10ZM5.1 16H7.4C7.7 17.2 8 18.3 8.5 19.2C7.1 18.5 5.9 17.4 5.1 16ZM9.5 16H14.5C13.8 18.5 12.7 20 12 20C11.3 20 10.1 18.5 9.5 16ZM15.5 19.2C16 18.3 16.4 17.2 16.6 16H18.9C18.1 17.4 16.9 18.5 15.5 19.2ZM19.7 14H16.9C17 13.4 17 12.7 17 12C17 11.3 17 10.6 16.9 10H19.7C19.9 10.6 20 11.3 20 12C20 12.7 19.9 13.4 19.7 14Z',
    })
  )
}
